// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__rE-w0","content":"LoadingAlert_content__3KMQC"};